import { VideoActionTypes } from "../actions/Video";

function video(state = {}, action = {}) {
    switch (action.type) {
        case VideoActionTypes.VIDEO_API_ERROR:
        case VideoActionTypes.HANDLE_VIDEO_API_RESPONSE:
            return { ...state, ...action.data };
        default:
            return state;
    }
}

export default video;
